@if (open()) {
  <div class="modal-scrim" role="dialog" aria-modal="true" aria-labelledby="idTitle" (click)="cancel.emit()">
    <div class="modal id-modal" (click)="$event.stopPropagation()">
      <div class="modal-head">
        <h2 id="idTitle">Who's leaving this feedback?</h2>
        <p>Just so the team knows who to follow up with on this thread.</p>
      </div>
      <div class="modal-body id-body">
        <label class="id-field">
          <span>Name</span>
          <input
            type="text"
            autocomplete="name"
            placeholder="Jane Doe"
            [class.is-invalid]="nameInvalid()"
            [value]="name()"
            (input)="name.set($any($event.target).value)"
            (keydown.enter)="onContinue()"
          />
        </label>
        <label class="id-field">
          <span>Email</span>
          <input
            type="email"
            autocomplete="email"
            placeholder="jane@company.com"
            [class.is-invalid]="emailInvalid()"
            [value]="email()"
            (input)="email.set($any($event.target).value)"
            (keydown.enter)="onContinue()"
          />
        </label>
        <div class="id-note">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>
          <span>This information is not shared. It's used purely so the team can reach out about your feedback.</span>
        </div>
      </div>
      <div class="modal-foot">
        <button class="btn" type="button" (click)="cancel.emit()">Cancel</button>
        <button class="btn primary" type="button" (click)="onContinue()">Continue</button>
      </div>
    </div>
  </div>
}
